import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const AzureBlob = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
  <SvgIcon
    data-test="AzureBlob"
    height={height}
    width={width}
    title="Azure Blob logo"
    titleId="azure-blob-logo-title"
    viewBox="0 0 256 256"
    {...props}
  >
    <defs>
      <linearGradient
        id="azure_ab40b385-f958-420f-bfab-714be1677426"
        x1="-960.606"
        y1="283.397"
        x2="-1032.511"
        y2="70.972"
        gradientTransform="matrix(1 0 0 -1 1075 318)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#114a8b" />
        <stop offset="1" stopColor="#0669bc" />
      </linearGradient>
      <linearGradient
        id="azure_f40af90d-72eb-49b3-94b2-2510f1071722"
        x1="-938.144"
        y1="184.402"
        x2="-954.778"
        y2="178.778"
        gradientTransform="matrix(1 0 0 -1 1075 318)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopOpacity=".3" />
        <stop offset=".071" stopOpacity=".2" />
        <stop offset=".321" stopOpacity=".1" />
        <stop offset=".623" stopOpacity=".05" />
        <stop offset="1" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="azure_e382d742-7d51-4974-a256-24e182eef053"
        x1="-947.292"
        y1="289.594"
        x2="-868.363"
        y2="79.308"
        gradientTransform="matrix(1 0 0 -1 1075 318)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#3ccbf4" />
        <stop offset="1" stopColor="#2892df" />
      </linearGradient>
    </defs>
    <path
      d="M89.158 18.266h69.238L86.523 231.224a11.041 11.041 0 01-10.461 7.51H22.179a11.023 11.023 0 01-10.445-14.548l66.963-198.41a11.04 11.04 0 0110.461-7.51z"
      fill="url(#azure_ab40b385-f958-420f-bfab-714be1677426)"
    />
    <path
      d="M189.77 161.104H79.976a5.083 5.083 0 00-3.468 8.8l70.552 65.847a11.091 11.091 0 007.567 2.983h62.167z"
      fill="#0078d4"
    />
    <path
      d="M89.158 18.266a10.95 10.95 0 00-10.483 7.654L11.817 224.006a11.01 11.01 0 0010.393 14.728h55.274a11.814 11.814 0 009.069-7.714l13.33-39.29 47.625 44.418a11.267 11.267 0 007.089 2.586h61.937l-27.166-77.63-79.19.018 48.47-142.856z"
      fill="url(#azure_f40af90d-72eb-49b3-94b2-2510f1071722)"
    />
    <path
      d="M177.592 25.764a11.023 11.023 0 00-10.444-7.498H89.984a11.024 11.024 0 0110.445 7.498l66.967 198.421a11.024 11.024 0 01-10.445 14.549h77.164a11.024 11.024 0 0010.444-14.549z"
      fill="url(#azure_e382d742-7d51-4974-a256-24e182eef053)"
    />
  </SvgIcon>
);

// export const AzureBlob = ({ height = 24, width = 24, ...props }: SvgIconProps) => (
//   <SvgIcon height={height} width={width} viewBox="0 0 50 50" {...props}>
//     <path fill="#A0A1A2" d="M0,44.8c0,1,0.8,1.9,1.8,1.9h46.3c1,0,1.9-0.8,1.9-1.9l0-33.1H0V44.8z" />
//     <path fill="#7A7A7A" d="M48.1,4H1.8C0.8,4,0,4.9,0,5.9v5.7h50l0-5.7C50,4.9,49.2,4,48.1,4" />
//     <rect x="3.7" y="15.1" fill="#0072C6" width="20.4" height="13" />
//     <rect x="3.7" y="29.9" fill="#0072C6" width="20.4" height="13" />
//     <rect x="25.9" y="15.1" fill="#FFFFFF" width="20.3" height="13" />
//     <rect x="25.9" y="29.9" fill="#0072C6" width="20.3" height="13" />
//     <path
//       opacity="0.2"
//       fill="#FFFFFF"
//       d="M2,4C0.9,4,0,4.9,0,6v7.3v3.3v28c0,1.1,0.9,2,2,2h2.2L43.6,4H2z"
//     />
//   </SvgIcon>
// );
